// Email Template Action Constants
export const EMAIL_TEMPLATE_CONSTANTS = {
  // Fetch templates
  FETCH_EMAIL_TEMPLATES_REQUEST: 'FETCH_EMAIL_TEMPLATES_REQUEST',
  FETCH_EMAIL_TEMPLATES_SUCCESS: 'FETCH_EMAIL_TEMPLATES_SUCCESS',
  FETCH_EMAIL_TEMPLATES_FAIL: 'FETCH_EMAIL_TEMPLATES_FAIL',

  // Create template
  CREATE_EMAIL_TEMPLATE_REQUEST: 'CREATE_EMAIL_TEMPLATE_REQUEST',
  CREATE_EMAIL_TEMPLATE_SUCCESS: 'CREATE_EMAIL_TEMPLATE_SUCCESS',
  CREATE_EMAIL_TEMPLATE_FAIL: 'CREATE_EMAIL_TEMPLATE_FAIL',

  // Update template
  UPDATE_EMAIL_TEMPLATE_REQUEST: 'UPDATE_EMAIL_TEMPLATE_REQUEST',
  UPDATE_EMAIL_TEMPLATE_SUCCESS: 'UPDATE_EMAIL_TEMPLATE_SUCCESS',
  UPDATE_EMAIL_TEMPLATE_FAIL: 'UPDATE_EMAIL_TEMPLATE_FAIL',

  // Delete template
  DELETE_EMAIL_TEMPLATE_REQUEST: 'DELETE_EMAIL_TEMPLATE_REQUEST',
  DELETE_EMAIL_TEMPLATE_SUCCESS: 'DELETE_EMAIL_TEMPLATE_SUCCESS',
  DELETE_EMAIL_TEMPLATE_FAIL: 'DELETE_EMAIL_TEMPLATE_FAIL',

  // Reset states
  RESET_EMAIL_TEMPLATE_SUCCESS: 'RESET_EMAIL_TEMPLATE_SUCCESS',
  RESET_EMAIL_TEMPLATES: 'RESET_EMAIL_TEMPLATES'
}
